import React, { useMemo } from 'react';
import { BsFillCheckCircleFill, BsFillXCircleFill } from 'react-icons/bs';
import { Box, Grid, GridItem, HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import CopyToClipboardIconButton from '../../../../../components/CopyToClipboardIconButton';

const TxtRecord = ({
  title,
  status,
  name,
  value
}) => {
  const verified = useMemo(() => (status === 'valid'), [status]);

  return (
    <Box borderBottom="1px solid" borderBottomColor="greyScale.200" p={8}>
      <Box pr={4} textAlign="left">
        <Text mb={4} textStyle="bodyMd500">{title}</Text>
        <Grid gap={6} templateColumns="repeat(10, 1fr)">
          <GridItem colSpan={3}>
            <Box>
              <Text color="greyScale.500" mb={2} textStyle="bodySm">Status</Text>
              <HStack spacing={2}>
                <Icon as={verified ? BsFillCheckCircleFill : BsFillXCircleFill} color={verified ? 'success.primary.600' : 'error.primary.600'} />
                <Text color="greyScale.700" textStyle="bodyMd">{verified ? 'Verified' : 'Unverified'}</Text>
              </HStack>
            </Box>
          </GridItem>

          <GridItem colSpan={3}>
            <Box>
              <Text color="greyScale.500" mb={2} textStyle="bodySm">Hostname</Text>
              <Text color="greyScale.700" textStyle="bodyMd">{name}</Text>
            </Box>
          </GridItem>

          <GridItem colSpan={3}>
            <Text color="greyScale.500" mb={2} textStyle="bodySm">Enter this value</Text>

            <Text color="greyScale.700" textStyle="bodyMd">{value}</Text>
          </GridItem>

          <GridItem colSpan={1}>
            <CopyToClipboardIconButton text={value} variant="textPrimary" />
          </GridItem>
        </Grid>
      </Box>
    </Box>
  );
};

TxtRecord.propTypes = {
  title: PropTypes.string,
  status: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string
};

export default TxtRecord;
